import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const bayshoreGardensConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Bayshore Gardens Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Bayshore Gardens, FL. Sam\'s Tree Service handles hazardous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_bayshore_gardens',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Bayshore Gardens',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Bayshore Gardens Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we take care of the tree work that keeps 
     homes and properties safe across <strong>Bayshore Gardens</strong>. This established 
     waterfront community is full of mature trees that add beauty and shade but also 
     require regular professional attention to stay safe. Overhanging limbs, storm weakened 
     canopies, and trees pushing against structures are all situations our experienced crew 
     handles with skill and precision.`,

    `We specialize in <strong>hazardous tree removal and targeted trimming</strong> 
     tackling large limb overhangs near rooftops and docks, trees damaged or leaning 
     after storms, dense canopy growth increasing wind load risk, and palms crowding 
     utility lines or fences. We protect your property and your neighbors throughout 
     every job.`,

    `<strong>Sam's Tree Service</strong> delivers expert, affordable tree care throughout 
     <strong>Bayshore Gardens</strong> and the surrounding <strong>Sarasota Bay</strong> 
     communities keeping your waterfront property safe and your trees in top condition 
     all year long.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Bayshore Gardens, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_BayshoreGardens = () => <LocationPage config={bayshoreGardensConfig} />;
export default Services_BayshoreGardens;
